<template>
  <header role="banner">
    <div class="titleBar">
      <div>
        <div class="logo"></div>
        <span class="titleText"><!-- Insert banner here if required --></span>
      </div>
    </div>
    <div class="banner">
      <v-container>
        <h1>Account activation</h1>
      </v-container>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style lang="scss">
@import '@/scss/ads.scss';

header {
  color: white;
  background-color: $ads-navy;
  margin-top: 43px;
  margin-bottom: 1.6rem;

  .titleBar {
    position: fixed;
    z-index: 10;
    top: 0;
    width: 100%;
    background-color: $ads-navy;
  }

  .banner {
    background-image: url('~@/assets/images/banner.jpg');
    background-size: cover;
  }
  .container {
    padding-top: 0;
    padding-bottom: 0;
  }
  h1 {
    font-weight: normal;
    font-size: 2.1rem;
    font-weight: bold;
    padding: 2.1rem 0;
  }
  .titleText {
    font-size: 1.25rem;
    font-weight: bold;
    display: inline-block;
    vertical-align: middle;
    padding: 1rem 0;
  }
  .logo {
    width: 43px;
    height: 43px;
    background-image: url(../assets/images/nsw-logo.svg);
    display: inline-block;
    vertical-align: middle;
    margin: 0 0.5rem 0 1.5rem;
  }
}
</style>
